<template>
    <div class="goods-list">
        <div class="goods-page-top">
            <div class="top-title">设计师创意成衣馆</div>
            <div class="top-desc">探索设计师们上线新品、全新系列及更多风格亮点,时刻领跑潮流</div>
        </div>
        <div class="goods-cate-list" v-if="false">
            <div class="cate-list-wraper">
                <div :class="['cate-item',{active:Number(query_form.category_id) === Number(item.product_category_id)}]" v-for="(item,index) in product_cate_list" :key="index" @click="onChangeCate(item.product_category_id)">
                    {{ item.category_name_cn }}
                </div>
            </div>
        </div>
        <div class="goods-list">
            <div class="goods-filter-box">
                <div class="filter-left">
                    <div :class="['filter-left-item',{active:query_form.sort_field == 'all'}]" @click="onChangeSort('all')">
                        综合
                    </div>
                    <div :class="['filter-left-item',{active:query_form.sort_field == 'sales'}]" @click="onChangeSort('sales')">
                        销量
                    </div>
                    <poptip trigger="hover" placement="bottom">
                        <template #content>
                            <div :class="['price-sort-item',{active:query_form.sort_order === 'desc'}]" @click="onChangeSort('sale_price','desc')">由高到低</div>
                            <div :class="['price-sort-item',{active:query_form.sort_order === 'asc'}]" @click="onChangeSort('sale_price','asc')">由低到高</div>
                        </template>
                        <div :class="['filter-left-item',{active:query_form.sort_field === 'sale_price'}]">
                            {{ query_form.sort_order | sort_price_text }}<Icon type="ios-arrow-down" />
                        </div>
                    </poptip>
                </div>
                <div class="filter-right">
                    <form class="search-input" @submit.prevent="onSearch">
                        <input placeholder="请输入关键词进行搜索" v-model="query_form.keyword" />
                        <Icon type="ios-search" style="cursor:pointer;" @click="onSearch" />
                    </form>
                    <!-- <div class="filter-btn">
                        <div class="filter-icon"></div>筛选
                    </div> -->
                </div>
            </div>
            <div class="goods-list-wraper" ref="listTop">
                <div class="loading-wrap" v-if="loading">
                    <Spin></Spin>
                </div>
                <div class="goods-item" v-for="(item,index) in product_list" :key="index" @click="onDetailClick(item)">
                    <div class="goods-cover">
                        <img :src="item.thumbUrl" class="goods-img thumb-img" :class="{ dimmed: imageLoaded[index] }" alt="" />
                        <img v-if="item.fullUrl" :src="item.fullUrl"
                             class="goods-img full-img"
                             :class="{ loaded: imageLoaded[index] }"
                             alt="" />
                        <div class="collect-btn" @click.stop="onCollectProduct(item.uuid,index)">
                            <img src="@/assets/images/icon-mall-collect.png" alt="" class="collect-icon">
                            {{ item.is_collected ? '已收藏' : '收藏' }}
                        </div>
                    </div>
                    <div class="goods-title">{{item.name}}</div>
                    <div class="goods-price">{{onPriceCalc(item)}}</div>
                    <div class="goods-author">
                        <img :src="(item.shop.logo || item.member.avatar) | default_img" alt="" class="avatar" />
                        <div class="nickname">{{(item.shop.shop_name || item.member.nickname)}}</div>
                        <div class="line">|</div>
                        <div class="count-num">作品:{{item.member.works||'0'}}</div>
                    </div>
                </div>
            </div>
        </div>
        <Page :current="query_form.page" :page-size="query_form.size"  :total="total" @on-change="changePage" style="margin-top: 20px;"></Page>
        <mall-side></mall-side>
    </div>
</template>
<script>
import { getMallCategoryList, getMallProductList, productCollect } from '@/api/index';
import MallSide from './components/MallSide';
export default{
    data(){
        return{
            query_form:{
                category_id:0,  //>分类
                sort_field:'all',  //>排序方式
                sort_order:'',
                page:1,  //>当前页码
                size:40,   //>每页数量
                keyword:''
            },
            total:0,
            product_cate_list:[],
            product_list:[],
            loading:false,
            imageLoaded:{}
        }
    },
    filters:{
        sort_price_text(val){
            switch(val){
                case 'desc':
                    return '由高到低';
                case 'asc':
                    return '由低到高';
                default:
                    return '价格';
            }
        }
    },
    components:{
        MallSide
    },
    mounted(){
        if(this.$route.query.cate_id){
            this.query_form.category_id = this.$route.query.cate_id;
        }
        if(this.$route.params.keyword){
            this.query_form.keyword = this.$route.params.keyword;
        }
        Promise.all([
            this.onGetMallCategoryList(),
            this.onGetMallProductList()
        ])
        this.$EventBus.$on('onHeaderSearch', (data) => {
            this.query_form.keyword = data?.keyword || '';
            this.onGetMallProductList(); // 执行你的搜索方法
        });
    },
    beforeDestroy() {
        this.$EventBus.$off('onHeaderSearch');
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
        // 通过 `vm` 访问组件实例
            vm.$emit("changeFooter", "mall");
        });
    },
    methods:{
        onPriceCalc(product){
            // console.log('product-price-calc',product);
            const {price_mode,price_step,sale_price} = product;
            if(price_mode == 1){
                return `¥${sale_price || '0'}`;
            }
            let min_price = '0',max_price = '0'
            if(price_step && price_step.length > 0){
                min_price = Math.min(...price_step.map(item=>Number(item.price)));
                max_price = Math.max(...price_step.map(item=>Number(item.price)));
            }
            return min_price == max_price ? `¥${min_price}` :`¥${min_price}~${max_price}`;
        },
        async onCollectProduct(uuid,index){
            try{
                const {code,msg} = await productCollect({uuid});
                if(code > 0){
                this.$layer.msg(msg);
                return;
                }
                this.product_list[index].is_collected = !this.product_list[index].is_collected;
                this.$layer.msg('操作成功~');
            }catch(e){
                console.log('err-collect',e);
            }
        },
        onDetailClick({uuid}){
            this.$router.push({name:'GoodsDetail',params:{uuid}});
        },
        onChangeSort(sort_type,sort=''){
            this.query_form.sort_field = sort_type;
            if(sort_type === 'sale_price'){
                this.query_form.sort_order = sort;
            }else{
                this.query_form.sort_order = '';
            }
            this.query_form.page = 1;
            this.product_list = [];
            this.onGetMallProductList();
            this.$nextTick(() => this.scrollToTop());
        },
        onChangeCate(cate_id){
            this.query_form.category_id = cate_id;
            this.query_form.page = 1;
            this.product_list = [];
            this.onGetMallProductList();
            this.$nextTick(() => this.scrollToTop());
        },
        async onGetMallProductList(){
            this.loading = true;
            try{
                const {code,data,msg} = await getMallProductList(this.query_form);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                // 为每个商品生成缩略图 URL
                data.list.forEach(item => {
                    if(item.image){
                        item.thumbUrl = item.image + '?x-oss-process=image/resize,w_30/quality,q_20';
                    }
                });
                this.product_list = data.list;
                this.total = data.count;
                this.imageLoaded = {};
                // 按顺序加载大图
                this.$nextTick(() => this.startSequentialLoad());
            }catch(e){
                console.error('getMallProductList error:', e);
            }finally{
                this.loading = false;
            }
        },
        async onGetMallCategoryList(){
            const {code,data,msg} = await getMallCategoryList({});
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.product_cate_list = [{product_category_id:'0',category_name_cn:'全部作品'},...data];
        },
        changePage(e){
            this.query_form.page = e;
            this.product_list = [];
            this.onGetMallProductList();
            this.$nextTick(() => this.scrollToTop());
        },
        onSearch(e){
            this.query_form.page = 1;
            this.product_list = [];
            this.onGetMallProductList();
            this.$nextTick(() => this.scrollToTop());
        },
        scrollToTop(){
            if(this.$refs.listTop){
                const top = this.$refs.listTop.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        },
        startSequentialLoad(){
            let i = 0;
            const loadNext = () => {
                if(i >= this.product_list.length) return;
                const item = this.product_list[i];
                const index = i;
                i++;
                if(item.image){
                    const img = new Image();
                    img.onload = () => {
                        this.$set(item, 'fullUrl', item.image);
                        // 等 Vue 渲染 full-img 后，延一帧让 transition 从 opacity:0 开始
                        this.$nextTick(() => {
                            requestAnimationFrame(() => {
                                this.$set(this.imageLoaded, index, true);
                                loadNext();
                            });
                        });
                    };
                    img.src = item.image;
                } else {
                    loadNext();
                }
            };
            loadNext();
        }
    }
}
</script>
<style lang="scss" scoped>
.goods-list{
    width:100%;
    user-select:none;
    .goods-page-top{
        width:100%;
        height:140px;
        background:url('../../assets/images/bg-mall-goods-list.png');
        background-size:cover;
        background-position:center;
        background-repeat:no-repeat;
        display:flex;
        align-items:center;
        justify-content:center;
        flex-direction:column;
        .top-title{
            font-size:30px;
            font-weight:bold;
            color:#ffffff;
            line-height:36px;
        }
        .top-desc{
            color:#999999;
            font-size:16px;
            line-height:36px;
        }
    }
    .goods-cate-list{
        width:100%;
        border-bottom:1px solid #ebebeb;
        .cate-list-wraper{
            padding:20px 100px;
            display:flex;
            align-items:center;
            flex-wrap:wrap;
            column-gap:25px;
            row-gap:10px;
            .cate-item{
                flex-shrink:0;
                color:#4d4d4d;
                font-size:16px;
                cursor:pointer;
                padding:13px 23px;
                &:hover, &.active{
                    color:#ffffff;
                    font-weight:bold;
                    background:#ff5967;
                    border-radius:30px;
                }
            }
        }
    }
    .goods-list{
        width:100%;
        padding:25px 100px;
        .goods-filter-box{
            display:flex;
            align-items:center;
            justify-content:space-between;
            .filter-left{
                display:flex;
                align-items:center;
                column-gap:8px;
                .price-sort-item{
                    font-size:14px;
                    line-height:36px;
                    cursor:pointer;
                    text-align:center;
                    color:#1a1a1a;
                    margin:5px auto;
                    &:hover, &.active{
                        color:#ffffff;
                        background:#ff5967;
                        border-radius:10px;
                    }
                }
                .filter-left-item{
                    font-size:14px;
                    color:#666666;
                    padding:0 13px;
                    line-height:36px;
                    border-radius:5px;
                    border:1px solid #ebebeb;
                    cursor:pointer;
                    &.active{
                        color:#fe4b5a;
                        border:1px solid #fe4b5a;
                    }
                }
            }
            .filter-right{
                display:flex;
                align-items:center;
                column-gap:17px;
                .search-input{
                    width:280px;
                    height:40px !important;
                    border-radius:20px !important;
                    border:1px solid #ebebeb;
                    padding:0 18px;
                    display:flex;
                    align-items:center;
                    input{
                        background:transparent;
                        border:none;
                        outline:none;
                        height:100%;
                        flex:1;
                    }
                }
                .filter-btn{
                    width:100px;
                    height:40px;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    border:1px solid #ebebeb;
                    border-radius:20px;
                    color:#666666;
                    font-size:14px;
                    cursor:pointer;
                    .filter-icon{
                        width:20px;
                        height:20px;
                        background:url('../../assets/images/icon-mall-goods-filter.png');
                        background-repeat:no-repeat;
                        background-size:cover;
                        background-position:center;
                    }
                }
            }
        }
        .goods-list-wraper{
            width:100%;
            margin-top:28px;
            display:flex;
            flex-wrap:wrap;
            gap:25px;
            min-height:400px;
            position:relative;
            .loading-wrap{
                width:100%;
                height:400px;
                display:flex;
                align-items:center;
                justify-content:center;
            }
            .goods-item {
                width: calc(100% / 5 - 25px);
                background: #ffffff;
                display: flex;
                flex-direction: column;
                align-items: stretch;

                .goods-cover {
                    width: 100%;
                    height:430px;
                    // height:auto;
                    min-height:0;
                    // aspect-ratio:1;
                    // max-height: 430px;
                    border-radius: 6px;
                    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
                    overflow: hidden;
                    position: relative;
                    // aspect-ratio:1;
                    display:flex;

                    img.goods-img {
                        width: 100%;
                        height: 100%;
                        display:block;
                        border-radius: 6px;
                        object-fit: cover;
                    }

                    .thumb-img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        image-rendering: pixelated;
                        transition: opacity 1.2s ease;
                        &.dimmed {
                            opacity: 0;
                        }
                    }

                    .full-img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        opacity: 0;
                        transform: scale(1.1);
                        transition: opacity 1.2s ease, transform 1.2s ease;

                        &.loaded {
                            opacity: 1;
                            transform: scale(1);
                        }
                    }

                    .collect-btn {
                        display: none;
                    }

                    &:hover {
                        .collect-btn {
                            position: absolute;
                            right: 20px;
                            bottom: 20px;
                            background: rgba(255, 255, 255, 0.7);
                            border-radius: 16px;
                            color: #4d4d4d;
                            font-size: 12px;
                            display: flex;
                            align-items: center;
                            column-gap:4px;
                            padding: 6px 10px;
                            cursor: pointer;
                            max-height:32px;

                            .collect-icon {
                                width: 20px;
                                height: 20px;
                                max-height:20px;
                                min-height:20px;
                            }
                        }
                    }
                }

                .goods-title {
                    // margin-top:20px;
                    line-height: 35.81px;
                    color: #1a1a1a;
                    font-size: 16px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .goods-price {
                    line-height: 35.81px;
                    color: #1a1a1a;
                    font-size: 18px;
                    font-weight: bold;
                }

                .goods-author {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    .avatar {
                        width: 25px;
                        height: 25px;
                        border-radius: 50%;
                        margin-right: 9px;
                    }

                    .line {
                        margin: 0 9px;
                        font-size: 13px;
                    }

                    .nickname,
                    .count-num {
                        flex: 0 0 1;
                        color: #666666;
                        font-size: 13px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
}
</style>